import React, { useState, useEffect } from 'react'

const Impact = ({ ImpactContent, ...props }) => {
  const [ status, setStatus ] = useState('loading')
  const [ widgets, setWidgets ] = useState(() =>
    props.widgets.map(widget => ({ amount: 0, ...widget }))
  )

  useEffect(() => {
    const loadData = () => {
      const url = [
        props.widgetsUrl,
        props.widgets.map(w => w.token).join(','),
      ].join('/')

      fetch(url, {
        headers: { Accept: 'application/json' },
      }).then(response => response.json()).then(json => {
        setWidgets(widgets => widgets.map(widget => ({
          ...widget,
          ...json.find(x => x.token == widget.token),
        })))
        setStatus('updated')
      })
    }

    loadData()
    const interval = setInterval(loadData, props.interval)
    return () => clearInterval(interval)
  }, [])

  return <ImpactContent {...props} status={status} widgets={widgets} />
}

export default Impact
